import React from 'react';

interface StarRatingProps {
  reviewScore?: number;
  reviewCount?: number;
  showReviewCount?: boolean;
  showScore?: boolean;
  showVerified?: boolean;
}

const CSSStars: React.FC<{ value: number }> = ({ value }) => {
  const percentage = Math.round((value / 5) * 100);
  return (
    <span
      style={{ position: 'relative', display: 'inline-block', fontSize: '1.1rem', lineHeight: 1 }}
      aria-label={`${value} out of 5 stars`}
    >
      <span style={{ color: 'var(--color-border-strong)', letterSpacing: '2px' }}>★★★★★</span>
      <span
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: `${percentage}%`,
          color: 'var(--color-warning)',
          letterSpacing: '2px',
        }}
      >
        ★★★★★
      </span>
    </span>
  );
};

const StarRating: React.FC<StarRatingProps> = ({ reviewScore, reviewCount, showReviewCount = true, showScore = true, showVerified = false }) => {
  if (!reviewScore) {
    return null;
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
      <CSSStars value={reviewScore} />
      {showScore && (
        <span style={{ fontSize: '0.875rem', fontWeight: 400 }}>
          {reviewScore.toFixed(1)}
        </span>
      )}
      {showVerified ? (
        <span style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem' }}>
          Verified purchases
        </span>
      ) : showReviewCount && reviewCount ? (
        <span style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem' }}>
          ({reviewCount} review{reviewCount !== 1 ? 's' : ''})
        </span>
      ) : null}
    </span>
  );
};

export default StarRating;
